import Homepage from '@/pages/user/Homepage.vue'
import HomepageCarrousel from '@/pages/user/Homepage-Carousel.vue'
import HomepageKYC from '@/pages/user/HomepageKYC.vue'
import HomepageRTP from '@/pages/user/HomepageRTP.vue'
import HomepageRemittance from '@/pages/user/HomepageRemittance.vue'
import RedirectionPageOTP from '@/pages/user/RedirectionPageOTP.vue'
import PageAxepta from '@/pages/axepta/PageAxepta.vue'
import PageLoading from '@/components/common/spinner.vue'
import MandatePage from '@/pages/Manda/MandatePage.vue'
import FormPage from '@/pages/Manda/GroupFormPage.vue'
import FormPageSDD from '@/pages/Manda/GroupFormPageSDD.vue'
import FormPageUnitSDD from '@/pages/Manda/FormPageUnitSDD.vue'
import FormPageBulkSDD from '@/pages/Manda/FormPageBulkSDD.vue'
import FormPageSCT from '@/pages/Manda/GroupFormPageSCT.vue'
import MandateDetail from '@/pages/Manda/MandateDetails.vue'
import MandateTransactions from '@/pages/Manda/MandateTransactions.vue'
import PaymentScheduleListGroup from '@/pages/payment-schedules/PaymentScheduleListGroup.vue'
import FormPageUnitDbtr from '@/pages/Manda/FormPageUnitDbtr.vue'

export default [
  {
    path: '/profile/',
    component: require('@/pages/user/CMProfile.vue').default
  },
  {
    path: '/profile/edit',
    component: require('@/pages/user/CMProfileEdit.vue').default
  },
  {
    path: '/profile/changePassword',
    component: require('@/pages/user/CMChangePassword.vue').default
  },
  {
    path: '/login/',
    component: require('@/pages/user/CMLogin.vue').default
  },
  {
    path: '/OTP/:email/:otp/:ressource',
    component: RedirectionPageOTP
  },
  {
    path: '/register/:FirstName/:LastName/:Login/:Password',
    component: require('@/pages/user/CMRegister.vue').default
  },
  {
    path: '/register/',
    component: require('@/pages/user/CMRegister.vue').default
  },
  {
    path: '/home/',
    component: Homepage
  },
  {
    path: '/homecarrousel/',
    component: HomepageCarrousel
  },
  {
    path: '/home/KYC',
    component: HomepageKYC
  },
  {
    path: '/home/RTP',
    component: HomepageRTP
  },
  {
    path: '/home/Remittance',
    component: HomepageRemittance
  },
  {
    path: '/axepta/',
    component: PageAxepta
  },
  {
    path: '/loading/',
    component: PageLoading
  },
  {
    path: '/mandatpage/:type',
    component: MandatePage
  },
  {
    path: '/formpage/:type',
    component: FormPage
  },
  // {
  //   path: '/formpagesdd/:type',
  //   component: FormPageSDD
  // },
  {
    path: '/formpagesdd/cdtr/unit/',
    component: FormPageUnitSDD,
    props: true
  },
  {
    path: '/formpagesdd/cdtr/bulk/',
    component: FormPageBulkSDD,
    props: true
  },
  {
    path: '/formpagesct/:type',
    component: FormPageSCT
  },
  {
    path: '/mandatedetail/:mandateId',
    component: MandateDetail
  },
  {
    path: '/mandatetransactions',
    component: MandateTransactions
  },
  {
    path: '/payment-schedules/:type',
    component: PaymentScheduleListGroup,
    props:true
  },
  {
  path: '/Mandat_dbtr/:token?',
  component: FormPageUnitDbtr,
  props: true
}
]
